import type { TrackingFn } from '@change-corgi/core/react/tracking';

import { RedirectError } from 'src/shared/error';

import { isTrafficDisabled } from './isTrafficDisabled';
import type { FcmValues, Petition, Viewer } from './types';

export function handleRedirect(
	track: TrackingFn,
	{
		petition,
		viewer,
		fcmValues,
	}: {
		petition: Petition;
		viewer: Viewer;
		fcmValues: FcmValues;
	},
) {
	if (!petition.promotionSettings?.promotionEligible) {
		void track('combo_psf_promote_ineligible', {
			petition_id: petition.id,
			promotion_country_code: viewer.country.countryCode,
		});

		redirectToPsfShare(petition, 'promote_ineligible');
	}

	if (isTrafficDisabled({ viewer, gradualOpeningFcm: fcmValues.gradualOpening })) {
		void track('combo_psf_traffic_disabled', {
			petition_id: petition.id,
			promotion_country_code: viewer.country.countryCode,
		});

		redirectToPsfShare(petition, 'traffic_disabled');
	}

	if (petition.status !== 'PUBLISHED') {
		void track('combo_psf_petition_not_published', {
			petition_id: petition.id,
			petition_status: petition.status.toLowerCase(),
		});
		throw new RedirectError({
			url: `/p/${encodeURIComponent(petition.slug)}`,
			reason: 'not_published',
		});
	}

	if (!petition.discoverable) {
		void track('combo_psf_petition_not_discoverable', {
			petition_id: petition.id,
		});
		redirectToPsfShare(petition, 'not_discoverable');
	}
}

function redirectToPsfShare(petition: Petition, reason: string) {
	throw new RedirectError({
		url: `/p/${encodeURIComponent(petition.slug)}/psf/share`,
		reason,
		forwardQueryParams: ['guest', 'short_display_name', 'allow_actions', 'message'],
	});
}
